$(document).ready(function () {
  $("#registrationForm").submit(function (evt) {
    evt.preventDefault();

    const email = $(this).find("#reg_email");
    const password = $(this).find("#reg_password");
    const password_confirm = $(this).find("#reg_password_confirm");

    // client side validation
    if (email.val() == "") {
      $.jGrowl("Введите E-mail", { theme: "tickets-message-error" });
      return false;
    }

    if (password.val() == "") {
      $.jGrowl("Введите пароль", { theme: "tickets-message-error" });
      return false;
    }

    if (password_confirm.val() == "") {
      $.jGrowl("Введите пароль ещё раз", { theme: "tickets-message-error" });
      return false;
    }

    // регистрируем пользователя
    $.ajax({
      type: "POST",
      cache: false,
      url: "ajax/register2",
      data: {
        fullname: email.val(),
        email: email.val(),
        password: password.val(),
        password_confirm: password_confirm.val(),
        registerbtn: "Регистрация",
        nospam: "",
      },

      success: function (response) {
        // server side validation
        let responseErrorEmail = $(response).filter(".error-email").text();
        let responseErrorPass = $(response).filter(".error-password").text();
        let responseErrorConfPass = $(response)
          .filter(".error-cpassword")
          .text();
        if (responseErrorEmail != "") {
          $.jGrowl(responseErrorEmail, { theme: "tickets-message-error" });
          return false;
        }
        if (responseErrorPass != "") {
          $.jGrowl("Пароль: " + responseErrorPass, {
            theme: "tickets-message-error",
          });
          return false;
        }
        if (responseErrorConfPass != "") {
          $.jGrowl(responseErrorConfPass, { theme: "tickets-message-error" });
          return false;
        }
        if (response == "regsuccess") {
          $.jGrowl("Регистрация прошла успешно", {
            theme: "tickets-message-success",
          });

          $("#registrationModal").removeClass("modal--active");
          $("#messageModal .js-modal-content").html(
            `На вашу почту отправлено<br>письмо с подтверждением!`
          );
          $("#messageModal").addClass("modal--active");
        }
      },
    });
  });

  // форма сброса пароля
  $("#resetPasswordForm").submit(function (evt) {
    evt.preventDefault();
    const data = $(this).serializeArray();

    data.push({ name: "back_url", value: $(this).prop("action") });
    data.push({ name: "this_res_id", value: $(this).find("#thisResId").val() });

    $.ajax({
      type: "POST",
      cache: false,
      url: "ajax/forgotpassword",
      data: data,
      success: function (response) {
        $("#recoveryModal").removeClass("modal--active");
        $("#messageModal .js-modal-content").html(
          `На вашу почту отправлено<br>письмо с подтверждением!`
        );
        $("#messageModal").addClass("modal--active");
      },
    });
  });

  $(document).ready(function () {
    if ($("#loginErrors").val()) {
      $.jGrowl($("#loginErrors").val(), { theme: "tickets-message-error" });
    }
  });

  const avatarInput = $("#photo");
  const avatarImg = $(".profile-intro__avatar");
  const avatarSource = $(".profile-intro__source");

  avatarInput.change(function () {
    // Сразу меняем аватарку на фронте
    const [file] = avatarInput.prop("files");

    if (file.type.startsWith("image/")) {
      const newAvatar = URL.createObjectURL(file);
      if (avatarImg.length) {
        avatarImg.attr("src", newAvatar);
        avatarSource.attr("srcset", newAvatar);
      } else {
        const userName = $(".profile-intro__name").text();
        const picture = `
                <img width="128" height="128" loading="lazy" alt="${userName}" title="${userName}" class="profile-intro__avatar"
                     src="${newAvatar}">
            `;
        $(".profile-intro__photo").prepend(picture);
        $(".profile-intro__photo .comment__html-ava").remove();
      }

      const formData = new FormData();
      formData.append("photo", file);
      $.ajax({
        type: "POST",
        cache: false,
        url: "ajax/updateavatar",
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
          $(".profile-intro__upload").addClass("profile-intro__upload--done");

          $.jGrowl("Фото обновлено", { theme: "tickets-message-success" });
        },
      });
    }
  });

  function popupClose() {
    $(".modal").removeClass("modal--active");
    $(".mask").removeClass("mask--active");
    $("html").removeClass("noscroll");
    $(".search__wrapper").removeClass("search__wrapper--active");
    $(".header").removeClass("header--mask");
  }

  $("#updateProfileForm").submit(function (evt) {
    evt.preventDefault();

    const fullname = $(this).find("#updateFullName");
    const comment = $(this).find("#updateDescription");

    if (!fullname.val().trim()) {
      $.jGrowl("Введите Имя", { theme: "tickets-message-error" });
      return false;
    }

    $.ajax({
      type: "POST",
      cache: false,
      url: "ajax/updateprofile",
      data: {
        fullname: fullname.val(),
        comment: comment.val(),
      },
      success: function (response) {
        // Обновляем данные на фронте
        $(".profile-intro__name").text(fullname.val());
        $(".profile-intro__description").text(comment.val());

        $.jGrowl("Данные обновлены", { theme: "tickets-message-success" });

        if ($(".profile-intro__avatar").length) {
          $(".profile-intro__avatar").prop("alt", fullname.val());
          $(".profile-intro__avatar").prop("title", fullname.val());
        }

        if ($(".profile-intro__photo .comment__html-ava").length) {
          $(".profile-intro__photo .comment__html-ava").text(fullname.val()[0]);
        }

        popupClose();
      },
    });
  });

  // Обновление БК, в которых играет юзер
  $("#updateBksForm").submit(function (evt) {
    evt.preventDefault();

    let userBkIds = "";
    const ptofileBks = document.querySelectorAll(
      "input[name='ptofileBks']:checked"
    );

    if (ptofileBks.length) {
      ptofileBks.forEach((item) => {
        userBkIds += item.value + ",";
      });
    }

    userBkIds = userBkIds.slice(0, -1);
    if (userBkIds.trim()) {
      $.ajax({
        type: "POST",
        cache: false,
        url: "ajax/updateprofile",
        data: {
          userBkIds: userBkIds,
        },
        success: function (response) {
          $.jGrowl("Данные обновлены", { theme: "tickets-message-success" });

          popupClose();

          $.ajax({
            type: "POST",
            cache: false,
            url: "ajax/fetchprofilebks",
            data: {
              userBkIds: userBkIds,
            },
            success: function (response) {
              $("#profileBksList").html(response);
            },
          });
        },
      });
    } else {
      $("#profileBksList").html(
        '<div class="profile-bks"><p class="profile-bks__empty">Букмекеры не выбраны</p></div>'
      );

      $.jGrowl("Данные обновлены", { theme: "tickets-message-success" });

      popupClose();
    }
  });

  // Обновление интересов юзера
  $("#updateInterestsForm").submit(function (evt) {
    evt.preventDefault();

    let userInterests = "";
    const interests = document.querySelectorAll(
      "input[name='profileInterests']:checked"
    );

    if (interests.length) {
      interests.forEach((item) => {
        userInterests += item.value + ",";
      });
    }

    userInterests = userInterests.slice(0, -1);

    $.ajax({
      type: "POST",
      cache: false,
      url: "ajax/updateprofile",
      data: {
        userInterests: userInterests,
      },
      success: function (response) {
        $.jGrowl("Данные обновлены", { theme: "tickets-message-success" });

        popupClose();

        if (userInterests) {
          const userInterestsLabels = {
            tennis: "Тенис",
            soccer: "Футбол",
            boxing: "Бокс",
            cybersport: "Киберспорт",
            hockey: "Хоккей",
          };
          let interestsList = "";
          const userInterestsArr = userInterests.split(",");

          userInterestsArr.forEach((userInterestItem) => {
            const interestsItem = `
                        <li class="interests-list__item">
                            <div class="interests-list__icon interests-list__icon--${userInterestItem}"></div>
                            <div class="interests-list__title">
                                ${userInterestsLabels[userInterestItem]}
                            </div>
                        </li>
                    `;
            interestsList += interestsItem;
          });
          $("#interestsList").html(interestsList);
        } else {
          $("#interestsList").html(
            '<li class="interests-list__empty">Интересы не выбраны</li>'
          );
        }
      },
    });
  });

  function unsubscribe(response, userId) {
    // удаляем из куки
    let subscriptions = JSON.parse(getCookie("subscriptions"));

    if (subscriptions && subscriptions.includes(userId)) {
      subscriptions = subscriptions.filter(function (f) {
        return f != userId;
      });
      setCookie("subscriptions", subscriptions);
    }

    $(".js-profile-subscribers-value").text(response);
    $.jGrowl("Подписка отменена", { theme: "tickets-message-success" });
  }

  function subscribe(response, userId) {
    // записываем в куки
    let subscriptions = getCookie("subscriptions");
    if (subscriptions) {
      subscriptions = JSON.parse(subscriptions);
      if (!subscriptions.includes(userId)) {
        subscriptions.push(userId);
        setCookie("subscriptions", JSON.stringify(subscriptions), {
          expires: "Fri, 31 Dec 9999 23:59:59 GMT",
        });
      }
    } else {
      setCookie("subscriptions", JSON.stringify([userId]), {
        expires: "Fri, 31 Dec 9999 23:59:59 GMT",
      });
    }

    $(".js-profile-subscribers-value").text(response);
    $.jGrowl("Подписка оформлена", { theme: "tickets-message-success" });
  }

  // подписка на юзера
  $("#profileSubscribe").click(function (evt) {
    evt.preventDefault();

    $(this).prop("disabled", true);

    const userId = $("#userId").val();

    $.ajax({
      type: "POST",
      cache: false,
      url: "ajax/profilesubscribe",
      data: {
        userId: userId,
        action: "add",
      },
      success: function (response) {
        subscribe(response, userId);
      },
    });
  });

  // отписка от юзера
  $("#profileUnSubscribe").click(function (evt) {
    evt.preventDefault();

    $(this).prop("disabled", true);

    const userId = $("#userId").val();

    $.ajax({
      type: "POST",
      cache: false,
      url: "ajax/profilesubscribe",
      data: {
        userId: userId,
        action: "sub",
      },
      success: function (response) {
        unsubscribe(response, userId);
      },
    });
  });

  // подписка на автора
  $("#profileSubscribeAuthor").click(function (evt) {
    evt.preventDefault();

    $(this).prop("disabled", true);

    const userId = $("#userId").val();

    $.ajax({
      type: "POST",
      cache: false,
      url: "ajax/profilesubscribeauthor",
      data: {
        userId: userId,
        action: "add",
      },
      success: function (response) {
        subscribe(response, userId);
      },
    });
  });

  // отписка от автора
  $("#profileUnSubscribeAuthor").click(function (evt) {
    evt.preventDefault();

    $(this).prop("disabled", true);

    const userId = $("#userId").val();

    $.ajax({
      type: "POST",
      cache: false,
      url: "ajax/profilesubscribeauthor",
      data: {
        userId: userId,
        action: "sub",
      },
      success: function (response) {
        unsubscribe(response, userId);
      },
    });
  });
});
